import { browserHistory } from '@hotjar/webapp/utils/routing/browser-history';
import { getRoute } from './get-route';
import type { Params } from './types';

/**
 * This function pushes a new route to the browser history.
 * Please see the docs for `getRoute` for more usage info.
 * @see {@link getRoute}
 */
export function navigateTo(route: string, data: Params = {}): void {
  browserHistory.push(getRoute(route, data));
}

export const navigateToOverview = (siteId: string | null): void =>
  browserHistory.replace(`sites/${siteId}/overview${window.location.search}`);
